// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L5G9h","label":"styles_label__C891b"};